import * as request from '@/utils/request'

/**
 * 自动生成 api代码【模块名：红人分成表】
 * 生成日期：2025/11/07 15:07:24
 * 生成路径: src/api/artist_divide.js
 * 生成人：超级管理员
 */

/**
 * @description 获取列表
 * @param {*} data
 * @returns
 */
export function getArtistDivideList(data) {
  return request.post('/artist_divide/list', data)
}
/**
 * @description 保存
 * @param {*} data
 * @returns
 */
export function saveArtistDivide(data) {
  return request.post('/artist_divide/store', data)
}
/**
 * @description 更新经纪人
 * @date 2022-08-01
 * @returns
 */
export function updateArtistDivideAgent(data) {
  return request.post('/artist_divide/update_agent', data)
}

/**
 * @description 获取详情
 * @param id
 * @returns
 */
export function getArtistDivideInfo(id) {
  let data = { id: id }
  return request.post('/artist_divide/get_info', data)
}

/**
 * @description 获取详情
 * @param where
 * @returns
 */
export function queryArtistDivideInfo(where) {
  return request.post('/artist_divide/query', where)
}

/**
 * @description 根据id删除单条信息
 * @param id
 * @returns
 */
export function deleteArtistDivide(id) {
  let data = { id: id }
  return request.post('/artist_divide/delete', data)
}

/**
 * 导入
 * @param data
 * @returns {Promise}
 */
export function importArtistDivides(data) {
  return request.post('/artist_divide/import', data)
}

/**
 * 导出
 * @param data
 * @returns {Promise}
 */
export function exportArtistDivides(data) {
  return request.postBlob('/artist_divide/export', data)
}
/**params
 * 订单明细来源查询
 * @param data
 * @returns {Promise}
 */
export function  queryOrderSourceArtistDivide(data) {
  return request.post('/artist_divide/queryOrderSource', data)
}

/**
 * 同步
 * @param data
 * @returns {Promise}
 */
export function syncArtistDivide(data) {
  return request.post('/artist_divide/sync', data)
}
/**
 * 同步
 * @param id
 * @returns {Promise}
 */
export function syncOrdersArtistDivide(id) {
  return request.post('/artist_divide/sync_orders', { id:id })
}

/**
 * 重置状态
 * @param ids
 * @returns {Promise}
 */
export function resetStatusArtistDivide(ids) {
  return request.post('/artist_divide/resetStatus', { ids: ids })
}